export function getAnalysisBodyHtml(analysis) {
  const introduction = analysis?.introduction;
  const bodyContent = analysis?.content;

  if (!introduction && !bodyContent) {
    return null;
  }

  const separator = introduction && bodyContent ? "<hr />" : "";

  return `${introduction ?? ""}${separator}${bodyContent ?? ""}`;
}

export function getAuthorData(analysis, endCharacter = null) {
  const { first_name, last_name, job_title } = analysis.author;

  let name = "";

  if (first_name || last_name) {
    name = `${first_name} ${last_name}`.trim();
  }

  if (job_title) {
    name = `${name}, ${job_title}`;
  }

  if (name && endCharacter) {
    name = `${name} ${endCharacter} `;
  }

  return name;
}

export function getAuthorPhoto(analysis) {
  const { photo } = analysis.author;

  return photo;
}
